// extracted by mini-css-extract-plugin
export default {"articles":"Articles_articles__7vW4v"};